import React from "react";
import {Box, CircularProgress, Paper, Stack, Typography} from "@mui/material";
import {useAppSettings} from "../settings/appSettings";

type Props = {
    label?: string;
    subtitle?: string;
    minHeight?: string | number;
};

const AppLoader = ({label = "Chargement…", subtitle = "Veuillez patienter", minHeight = "60vh"}: Props) => {
    const settings = useAppSettings();
    const logoSrc = settings.eventLogoDataUrl || "/logo512.png";
    return (
        <Box
            role="status"
            aria-live="polite"
            aria-busy
            sx={{
                minHeight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
            }}
        >
            <Paper className="panel" sx={{p: 3, width: "100%", maxWidth: 420}}>
                <Stack spacing={2.5} alignItems="center">
                    <Box sx={{position: "relative", width: 96, height: 96, display: "grid", placeItems: "center"}}>
                        <CircularProgress size={96} thickness={3.6} color="inherit"/>
                    <Box
                        component="img"
                        src={logoSrc}
                        alt="Loto"
                        sx={{position: "absolute", width: 56, height: 56}}
                    />
                    </Box>

                    <Stack spacing={0.5} alignItems="center">
                        <Typography variant="h6" fontWeight={900}>
                            {label}
                        </Typography>
                        <Typography variant="body2" sx={{opacity: 0.75}}>
                            {subtitle}
                        </Typography>
                    </Stack>
                </Stack>
            </Paper>
        </Box>
    );
};

export default AppLoader;
